import React from 'react';
export function SolutionSection() {
  const grades = ['1°', '2°', '3°', '4°', '5°', '6°'];
  const skills = ['Comprensión lectora', 'Escritura funcional', 'Matemática adaptada', 'Atención y lógica', 'Funciones ejecutivas', 'Organización visual', 'Habilidades funcionales', 'Autonomía escolar', 'Regulación emocional', 'Comprensión social'];
  const designFeatures = ['letra clara', 'menor sobrecarga visual', 'instrucciones simples', 'amplio espacio en blanco', 'progresión gradual', 'apoyo visual real'];
  return <section className="py-10 px-4 bg-white" data-id="element-140">
      <div className="max-w-4xl mx-auto text-center" data-id="element-141">
        <p className="text-[20px] font-black mb-2 text-[#F9327E]" data-id="element-142">
          La solución:
        </p>
        <h2 className="text-2xl md:text-4xl font-black mb-6 text-gray-900 leading-tight" data-id="element-143">
          UN SISTEMA COMPLETO DE INCLUSIÓN EDUCATIVA PARA TODA LA PRIMARIA
        </h2>

        <p className="text-lg md:text-xl text-gray-700 mb-4 max-w-3xl mx-auto" data-id="element-144">
          El <span className="font-bold" data-id="element-145">MEGAPACK INCLUSIÓN EDUCATIVA</span>{' '}
          está organizado de forma progresiva desde 1° hasta 6° grado para
          acompañar distintos ritmos de aprendizaje mediante actividades
          visuales, accesibles y multinivel.
        </p>

        <p className="text-base md:text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-146">
          Además, puede utilizarse de forma flexible según las habilidades y
          necesidades específicas de cada estudiante.
        </p>

        {/* ¿Cómo está organizado? */}
        <div className="bg-gray-50 rounded-2xl p-6 md:p-8 mb-8 border border-gray-100 shadow-sm text-left" data-id="element-147">
          <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-5 text-center" data-id="element-148">
            📚 ¿Cómo está organizado?
          </h3>

          {/* Grados */}
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-149">
            {grades.map(g => <div key={g} className="bg-white border-2 border-[#3CD0E4] text-gray-900 font-black w-14 h-14 flex items-center justify-center rounded-xl shadow-sm text-lg" data-id="element-150">
                {g}
              </div>)}
          </div>

          <ul className="space-y-2 max-w-xl mx-auto text-base md:text-lg text-gray-800" data-id="element-151">
            <li className="flex items-start gap-2" data-id="element-152">
              <span className="text-green-500 font-bold" data-id="element-153">✅</span>
              <span data-id="element-154">
                <strong data-id="element-155">6 grados</strong> completos
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-156">
              <span className="text-green-500 font-bold" data-id="element-157">✅</span>
              <span data-id="element-158">
                <strong data-id="element-159">5 bloques</strong> por grado
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-160">
              <span className="text-green-500 font-bold" data-id="element-161">✅</span>
              <span data-id="element-162">
                <strong data-id="element-163">20 actividades</strong> por bloque
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-164">
              <span className="text-green-500 font-bold" data-id="element-165">✅</span>
              <span data-id="element-166">
                Más de <strong data-id="element-167">100 actividades</strong> adaptadas por grado
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-168">
              <span className="text-green-500 font-bold" data-id="element-169">✅</span>
              <span data-id="element-170">
                Más de <strong data-id="element-171">600 actividades</strong> listas para imprimir
              </span>
            </li>
          </ul>
        </div>

        {/* Habilidades */}
        <div className="mb-8 text-left" data-id="element-172">
          <p className="text-lg md:text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-173">
            Cada grado trabaja habilidades fundamentales como:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 max-w-2xl mx-auto" data-id="element-174">
            {skills.map(s => <div key={s} className="flex items-center gap-2 text-gray-800 text-base md:text-lg" data-id="element-175">
                <span className="text-[#F9327E] font-bold" data-id="element-176">✔</span>
                <span data-id="element-177">{s}</span>
              </div>)}
          </div>
        </div>

        {/* Diseño */}
        <div className="bg-[#FFF5F8] rounded-2xl p-6 md:p-8 mb-8 border border-pink-100 text-left" data-id="element-178">
          <p className="text-lg md:text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-179">
            Todo el material fue diseñado con:
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-180">
            {designFeatures.map(f => <span key={f} className="bg-white border border-pink-200 text-gray-800 px-3 py-1.5 rounded-full text-sm md:text-base font-medium shadow-sm" data-id="element-181">
                ✨ {f}
              </span>)}
          </div>
        </div>

        <p className="text-xl md:text-2xl font-black text-gray-900" data-id="element-182">
          🖨️{' '}
          <span className="px-2 text-[#3CD0E4] bg-white" data-id="element-183">
            Descargas, imprimes y aplicas.
          </span>
        </p>
      </div>
    </section>;
}